
// import React, { Suspense } from "react";
import { Canvas } from '@react-three/fiber'
import { Loader } from '@react-three/drei'
import { EffectComposer, Bloom, ChromaticAberration } from '@react-three/postprocessing'
import { BlurPass, Resizer, KernelSize, BlendFunction } from 'postprocessing'
import MediaQuery from 'react-responsive'

import Stamp from '../Stamp'
import Stamp2 from '../Stamp2'
import Stamp3 from '../Stamp3'

export function Home() {
    return (
        <>
        <Canvas style={{ height: '100vh' }} >
    

        {/* <Suspense fallback={null}> */}
        

        <EffectComposer multisampling={8}>
 
        <Bloom 
         intensity={10.0} // The bloom intensity.
         // blurPass={undefined} // A blur pass.
         // width={visualViewport.width} // render width
         // height={visualViewport.height} // render height
         kernelSize={KernelSize.SMALL} // blur kernel size
         luminanceThreshold={0.5} // luminance threshold. Raise this value to mask out darker elements in the scene.
         luminanceSmoothing={0.5} // smoothness of the luminance threshold. Range is [0, 1]
         //      intensity={110.0} // The bloom intensity.
         //  luminanceThreshold={0.01} 
         //  luminanceSmoothing={1.9} 
         height={600}
         />
 
         <ChromaticAberration
         blendFunction={BlendFunction.DIVIDE} // blend mode
         offset={[-0.0019, 0.00016]} // color offset
         />
 
       </EffectComposer>
 
  {/* <Scene /> */}
 
       <MediaQuery maxWidth={768}>
     
       <Stamp/>
      
       </MediaQuery>
       <MediaQuery minWidth={769} maxWidth={ 1366}>
       <Stamp/>
       </MediaQuery>
 
 
       <MediaQuery minWidth={1367} maxWidth={1623}>
       <Stamp2/>
       </MediaQuery>
 
 
       <MediaQuery minWidth={1624}>
       <Stamp3/>
       </MediaQuery>

       {/* </Suspense> */}

       </Canvas>

       <Loader />

       </>
    )
}